import { Store } from "@storeLocator/storeType";
import { formatPhoneNumber } from "@utils";
import React from "react";
import { SPSection } from ".";

interface SPPhoneAddressSectionProps {
  store: Store;
}

const SPPhoneAddressSection = ({ store }: SPPhoneAddressSectionProps) => {
  return (
    <SPSection headline="Address & Phone">
      <div className="flex justify-between gap-5 font-body lg:text-lg">
        <p>
          <span>{store.streetAndNumber}</span>
          <br />
          <span>
            {store.city}, {store.province} {store.zip}
          </span>
        </p>
        <div className="flex flex-col items-end font-body">
          <p>
            <span className="font-bold">
              Ph:{" "}
              <a href={`tel:${store.phone}`} className="font-normal">
                {formatPhoneNumber(store.phone)}
              </a>
            </span>
          </p>
          {store?.fax && (
            <p>
              <span className="font-bold">
                Fax:{" "}
                <a href={`tel:${store.fax}`} className="font-normal">
                  {formatPhoneNumber(store.fax)}
                </a>
              </span>
            </p>
          )}
          <a
            href={`https://www.google.com/maps?saddr=Current+Location&daddr=@${store.lat},${store.lng}`}
            target="_blank"
            className="underline"
          >
            Get Directions
          </a>
        </div>
      </div>
    </SPSection>
  );
};

export default SPPhoneAddressSection;
